import MiniHero from "../components/hero/MiniHero";
import ContactAndTransportation from "../components/location/ContactAndTransportation";
import AddressMapContainer from "../components/location/AddressMap";


const Location = () => {



    return (
        <div>
            <MiniHero text={"Où nous rencontrer ?"} url={"/assets/img/theme/mini6.jpg"}/>
            <ContactAndTransportation/>
            <AddressMapContainer/>

        </div>
    );
};

export default Location;
